import { render, staticRenderFns } from "./FieldDropdown.vue?vue&type=template&id=048fd652&scoped=true"
import script from "./FieldDropdown.vue?vue&type=script&lang=js"
export * from "./FieldDropdown.vue?vue&type=script&lang=js"
import style0 from "./FieldDropdown.vue?vue&type=style&index=0&id=048fd652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048fd652",
  null
  
)

export default component.exports